import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class SHRDailyLeaveDTO  {
    _originalTypeClassName = "zSHR.BO.SHRDailyLeaveDTO";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
SHRDailyLeaveDTO.translate = translateService;
}
this.FullName = null;
this.DateFrom = null;
this.DateTo = null;
this.SHRDailyLeaveDTOKey = null;
this._key = this.SHRDailyLeaveDTOKey = 0; 
}

static translate: TranslateService;
_key: any;
FullName:any;
DateFrom:any;
DateTo:any;
private _SHRDailyLeaveDTOKey:any;
get SHRDailyLeaveDTOKey(): any {
    return this._SHRDailyLeaveDTOKey;
  }
set SHRDailyLeaveDTOKey(value: any) {
    this._SHRDailyLeaveDTOKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.SHRDailyLeaveDTOKey == null || $this.SHRDailyLeaveDTOKey == 0;
            }


}